import { useEffect, useState } from "react";

/** Ticks once a second — drives the top-bar clock and every ticket's live age timer. */
export function useNow(intervalMs = 1000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

/**
 * Mirrors the mockup's `D = width >= breakpoint` responsive check for the
 * 3-col board vs stacked layout. Listens for `orientationchange` as well as
 * `resize` — iOS Safari/PWA doesn't always fire `resize` reliably right
 * after a rotation (see apps/pos's useIsDesktop, which hit this same class
 * of bug: an iPad rotated to landscape stayed stuck on the narrow, single-
 * column layout from before the rotation because nothing re-measured
 * window.innerWidth).
 */
export function useIsWide(breakpoint = 880): boolean {
  const [isWide, setIsWide] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= breakpoint,
  );
  useEffect(() => {
    const onResize = () => setIsWide(window.innerWidth >= breakpoint);
    onResize();
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, [breakpoint]);
  return isWide;
}
